import { ColorModeScript } from "@chakra-ui/react";
import { createRoot } from "react-dom/client";
import * as serviceWorker from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import calculateViewHeight from "./calculateViewHeight";
import { Router } from "./scenes/Router";
import "./styles/index.css";
import { BrowserRouter } from "react-router-dom";
import { StrictMode } from "react";

const container = document.getElementById("root");
const root = createRoot(container!);

// WARNING!!! disabled strict mode by changing the tag to <> when debugging anything 
// related to markers or the map. 
root.render(
  <StrictMode>
    <ColorModeScript />
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  </StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
calculateViewHeight();
